import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { Subscription } from 'rxjs';
import { User } from '../shared/user.model';
declare var $: any;
@Component({
  selector: 'app-nonmember',
  templateUrl: './nonmember.component.html',
  styleUrls: ['./nonmember.component.css']
})
export class NonmemberComponent implements OnInit, OnDestroy {

  user: User;
  userSubscription = new Subscription();
  constructor(private userService: UserService) { 

  }
  ngOnDestroy(){
    this.userSubscription.unsubscribe();
  }
  ngOnInit() {
    this.userSubscription = this.userService.userChanged.subscribe(
      (user: User) => {
        this.user = user;
      }
    )
  }
}
